<template>
  <div class="container">
    <common-header></common-header>
    <div
      class="container-main"
      :class="[
        !supportSafeAreaLandscape ? 'page-not-support-safearea' : false,
        $platformClass,
      ]"
    >
      <slot></slot>
    </div>
    <transition>
      <div class="container-mask" @click="toggleMask" v-if="maskShow"></div>
    </transition>
    <toast></toast>
    <image-preview></image-preview>
  </div>
</template>
<script>
/* 公用的弹窗组件、头部组件都放这里， 处理全局事件 */
import Vue from 'vue';
import { TOGGLE_MASK } from '../../store/support/event-type.js';
import commonHeader from './header.vue';
import toast from './toast.vue';
// import { EventBus } from "../../utiles/index.js";
import { mapState, mapActions } from 'vuex';
import imagePreview from '../../plugins/imagePreview/image-preview.js';
import SupportSafeArea from '../../mixins/SupportSafeArea';
Vue.use(imagePreview);
export default {
  name: 'container',
  mixins: [SupportSafeArea],
  computed: {
    ...mapState({
      maskShow: state => state.support.maskShow,
    }),
  },
  methods: {
    ...mapActions(['mockSession']),
    toggleMask: function () {
      this.$store.commit(TOGGLE_MASK);
    },
  },
  components: {
    commonHeader,
    toast,
  },
};
</script>
<style lang="scss" scoped>
@import '../../assets/scss/support.scss';
@import '../../assets/scss/platform-support.scss';
.container {
  width: 100%;
  height: 100%;
  position: relative;
  &-main {
    width: 100%;
    height: 100%;
    padding: 100px 30px 0;
    position: relative;
    overflow: hidden;
  }
  &-mask {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    @include bgC(#000);
    opacity: 0.7;
  }
}
@media screen and (orientation: landscape) {
  .container {
    &-main {
      padding-left: constant(safe-area-inset-left); /* 兼容 iOS < 11.2 */
      padding-left: env(safe-area-inset-left); /* 兼容 iOS >= 11.2 */
      padding-right: constant(safe-area-inset-right); /* 兼容 iOS < 11.2 */
      padding-right: env(safe-area-inset-right); /* 兼容 iOS >= 11.2 */
    }
  }
  .page-not-support-safearea {
    padding-left: 30px;
    padding-right: 30px;
  }
}
</style>
